<template>
    <footer id="sticky-footer" class="py-4">
        <slot></slot>
    </footer>
</template>

<script>

    export default {
        name: "MJFooter"
    }
</script>

<style lang="scss" scoped>
    #sticky-footer {
        position: sticky;
        bottom: 0;
        flex-shrink: unset;
    }
    .slider-row {
        padding-top: 28px;
    }
</style>